import React from 'react';
import styles from 'styles/partials/_button.css';

const ExpandFormatter = (props) => {
  const handleClick = (e) => {
    e.preventDefault();

    const url = props.dependentValues.options.url + props.dependentValues.options.getId(props.dependentValues.rowData);

    window.open(`${window.location.origin}#${url}`, '_blank');
  };

  if (!props.dependentValues.rowData) return <div />;

  if (!props.dependentValues.options.getId(props.dependentValues.rowData)) return null;

  const _url = props.dependentValues.options.url + props.dependentValues.options.getId(props.dependentValues.rowData);

  const label = props.dependentValues.options.getLabel(props.dependentValues.rowData);

  return (
    <a
      onDragStart={(e) => {
        e.preventDefault();
      }}
      key={_url}
      href="#"
      onClick={(e) => {
        handleClick(e);
      }}
      className=""
      title={label}
    >
      <div className={styles.btnInfoSmall}>{label}</div>
    </a>
  );
};

export default ExpandFormatter;
